<template>
    <base-composable-checkpoint 
        :class="{ enabled: isEnabled }"
        :draggable="isEnabled && canWrite"
        :name="checkpoint.displayName"
        :style="{ 'user-select': (this.isEnabled && canWrite) ? 'auto' : 'none' }"
        
        @click.native="toggleFocusMode()"
    >
        <template #top>
            <notification-circle :notification-count="filterExclusionCheckpointsCount" />
        </template>
        
        <template #icon>
            <span class="fa-stack fa-1x">
                <i :class="checkpoint.iconClass" class="fa-stack-1x"></i>
                <i class="fas fa-ban fa-stack-2x"></i>
            </span>
        </template>
    </base-composable-checkpoint>
</template>

<script>
import { filterExclusionCheckpoint } from "@modules/JourneyBuilder/Bricks/Checkpoints";
import { mapState, mapMutations } from 'vuex';

import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
import injectJourneyMixin from '@modules/JourneyBuilder/Mixins/inject-journey';

import BaseComposableCheckpoint from "./BaseComposableCheckpoint";
import NotificationCircle from "@modules/JourneyBuilder/Components/Elements/NotificationCircle";

export default {
    name: "filer-exclusion-composable-checkpoint",
    components: {
        NotificationCircle,
        BaseComposableCheckpoint
    },
    mixins: [permissionsMixin, injectJourneyMixin],
    props: {
        checkpointName: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapState('journeyBuilder/composer', ['filterExclusionFocusMode']),
        checkpoint(){
            return filterExclusionCheckpoint;
        },
        isEnabled(){
            const filters = (this.journey.config && this.journey.config.filters) || [];
            return filters.length > 0;
        },
        filterExclusionCheckpointsCount(){
            //Take a shortcut for when no filters have been configured
            if(!this.isEnabled){
                return 0;
            }
            
            let enabledCheckpoints = 0;
            
            this.journey.bricks.forEach(brick => {
                brick.outgoingConnections.forEach(connection => {
                    if(filterExclusionCheckpoint.isActiveForConnection(connection)){
                        enabledCheckpoints++;
                    }
                });
            });
            
            return enabledCheckpoints;
        }
    },
    watch: {
        isEnabled(val){
            //Ensure focus mode is disabled
            if(!val){
                this.toggleFocusMode();
            }
        }
    },
    methods: {
        ...mapMutations('journeyBuilder/composer', ['toggleFilterExclusionFocusMode']),
        toggleFocusMode(){
            let enabled = !this.filterExclusionFocusMode;
            if(!this.isEnabled) {
                enabled = false;
            }
             
            this.toggleFilterExclusionFocusMode(enabled);
        }
    }
}
</script>

<style scoped lang="scss">
    .root {
        opacity: 0.4;
        
        &.enabled {
            opacity: 1;
            
           &:hover {
               cursor: pointer;
           } 
        }
    }
        
    img {
        width: 2rem;
    }

    .fa-ban {
        color: #E94B4B;
    }
    
    .notification-container {
        left: 10px;
        top: -10px;
    }
</style>